import { render, staticRenderFns } from "./KurccFormMultiChoiceAdditionalButtons.vue?vue&type=template&id=4a7ed908&"
import script from "./KurccFormMultiChoiceAdditionalButtons.vue?vue&type=script&lang=js&"
export * from "./KurccFormMultiChoiceAdditionalButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
